import { FC, ReactNode } from 'react';
import { LoadingScreen } from '@/components/base';
import { useProtectedRouteRoleGuard } from '@/hooks/routing/useProtectedRoute';
import { ActionType, LoadingLogData } from '@/interfaces/logging';
import { UserRole } from '@/model/User.model';

interface RoleGuardProps {
  roles: UserRole[];
  children: ReactNode;
}

const RoleGuard: FC<RoleGuardProps> = ({ roles, children }) => {
  const { isAuthenticating, isLogin, user } = useProtectedRouteRoleGuard(roles);

  if (isAuthenticating) {
    const loadingLogData: LoadingLogData = {
      action: ActionType.OnPageLoad,
      component: 'RoleGuard',
      description: 'Checking role permissions',
      context: { roles, isAuthenticating, isLogin, userId: user?.id },
    };
    return <LoadingScreen loadingLogData={loadingLogData} />;
  }

  return children;
};

export default RoleGuard;
